import { Container, Navbar, Nav, Image, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import logoHome from '../assets/logo-w.svg';
//import logoSubpage from '../assets/logo.svg';

export default function Navigation() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const logoSrc = isHome ? logoHome : logoHome;

  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar
      expand="lg"
      variant="dark"
      expanded={expanded}
      className="navbar-hero position-absolute w-100 top-0"
    >
      <Container>
        <Navbar.Brand as={Link} to="/">
          <Image src={logoSrc} height="80px" alt="BPP Logo" />
        </Navbar.Brand>

        {/* Custom hamburger toggle */}
        <Button className={`hamburger-toggle d-lg-none bg-transparent ${expanded ? 'open' : ''}`} onClick={() => setExpanded(!expanded)} aria-label="Toggle navigation"
        >
          <span />
          <span />
          <span />
        </Button>

        <Navbar.Collapse id="basic-navbar-nav" >
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/venue" onClick={() => setExpanded(false)}>Venue</Nav.Link>
            <Nav.Link as={Link} to="/abstracts" onClick={() => setExpanded(false)}>Abstracts</Nav.Link>
            <Nav.Link as={Link} to="/registration" onClick={() => setExpanded(false)}>Registration</Nav.Link>
            <Nav.Link as={Link} to="/programme" onClick={() => setExpanded(false)}>Programme</Nav.Link>
            <Nav.Link as={Link} to="/committees" onClick={() => setExpanded(false)}>Committees</Nav.Link>
            <Nav.Link as={Link} to="/social" onClick={() => setExpanded(false)}>Social</Nav.Link>
            <Nav.Link as={Link} to="/sponsors" onClick={() => setExpanded(false)}>Sponsors</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
